import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3630cb06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-row",
  style: {'flex-flow': 'row nowrap', 'width': 'fit-content'}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-sm font-serif text-note" }, " A ", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-sm font-monospace text-note" }, " A ", -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "menu-item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearFormatting && _ctx.clearFormatting(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'text-slash'],
        class: "sub icon-sm"
      })
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isBold}]),
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleBold && _ctx.toggleBold(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'bold'],
        class: "sub icon-sm"
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isItalic}]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleItalic && _ctx.toggleItalic(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'italic'],
        class: "sub icon-sm"
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isUnderline}]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleUnderline && _ctx.toggleUnderline(...args))),
      tabindex: "0"
    }, [
      _createVNode(_component_Icon, {
        icon: ['fal', 'underline'],
        class: "sub icon-sm"
      })
    ], 2),
    (_ctx.acceptTypography)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isSerif}]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleSerif && _ctx.toggleSerif(...args))),
          tabindex: "0"
        }, _hoisted_3, 2))
      : _createCommentVNode("", true),
    (_ctx.acceptTypography)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isMonospace}]),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleMonospace && _ctx.toggleMonospace(...args))),
          tabindex: "0"
        }, _hoisted_5, 2))
      : _createCommentVNode("", true),
    (_ctx.acceptTypography)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "menu-item",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleScript && _ctx.toggleScript(...args))),
          tabindex: "0"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon-sm font-script text-note", {'bg-cool': _ctx._isScript}])
          }, " A ", 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["menu-item", {'bg-cool': _ctx._isLink}]),
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleLink && _ctx.toggleLink(...args))),
      tabindex: "0"
    }, " Link ", 2),
    (_ctx._isLink)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "menu-item",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openLink && _ctx.openLink(...args))),
          tabindex: "0"
        }, [
          _createVNode(_component_Icon, {
            icon: ['fal', 'arrow-up-right-from-square'],
            class: "sub icon-sm"
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx._isLink)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 4,
          class: "flex-grow p-mention",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx._linkValue) = $event)),
          tabindex: "0"
        }, null, 512)), [
          [_vModelText, _ctx._linkValue]
        ])
      : _createCommentVNode("", true)
  ]))
}